import { Action, createReducer, on } from '@ngrx/store';
import { setStateAction } from '../actions/settings.actions';

export interface SettingsReducerInitialState {
  sideMenuCollapsedState: boolean;
  publicSideMenuVisible: boolean;
}

export const initialState: SettingsReducerInitialState = {
  sideMenuCollapsedState: true,
  publicSideMenuVisible: false,
};

const reducer = createReducer(
  initialState,
  on(setStateAction, (state, payload) => {
    return {
      ...state,
      ...payload,
    };
  })
);

export function settingsReducer(
  state: SettingsReducerInitialState,
  action: Action
) {
  return reducer(state, action);
}
